var map = {
	"./404.png": 8288,
	"./Daddy_Dream.png": 5589,
	"./Daddy_Dream_2.png": 1311,
	"./check-mark.gif": 8967,
	"./checkmark.gif": 599,
	"./classification-vis.png": 9172,
	"./docs/EjikemeDavid_CV.pdf": 7092,
	"./logo.png": 6949,
	"./pfp_1.png": 8668,
	"./pfp_2.png": 7557,
	"./pfp_3.jpg": 9613,
	"./pontus_logo.png": 777,
	"./vensmart.png": 4679
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;